"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropSourceSourceEnum = void 0;
exports.PropSourceSourceEnum = {
    Profile: 'Profile',
    RegistrationFlow: 'Registration Flow',
    UpdateSponsorship: 'Update Sponsorship',
    SponsorshipBanner: 'Sponsorship Banner',
    HomeDialog: 'HomeDialog',
    HomeRow: 'HomeRow',
    Home: 'Home',
    CompletedEmotionalCheckin: 'CompletedEmotionalCheckin',
    EmotionalCheckinHistory: 'EmotionalCheckinHistory',
    OverallEmotionalCheckinHistoryScreen: 'OverallEmotionalCheckinHistoryScreen',
    YourPlaylists: 'YourPlaylists',
    ThreeDotsView: 'ThreeDotsView',
    GuidePage: 'GuidePage',
    Onboarding: 'Onboarding',
    Shortcuts: 'Shortcuts',
    Deeplink: 'Deeplink',
};
//# sourceMappingURL=prop-source.js.map